<markant-platform-guided-tour-widget
  [guidedTour]="OA_ADMIN_AREA"
></markant-platform-guided-tour-widget>
